import { adapterForApi } from 'Utils/rtkq.utils';
import { createSelector } from '@reduxjs/toolkit';
import { dcpcApi } from './dcpcApi';
import { STATIONS_INVALIDATE_TAG, stationsSelector } from './stantionsApi';
import { tags } from './tags';
import { STATION_ENTITY_TAG } from './stationEntityApi';

export const DATASOURECES_INVALIDATE_TAG = 'DATASOURCES';

const {
  CREATE_DATASOURCE_PROGRAM_TAG, DELETE_DATASOURCE_PROGRAM_TAG,
} = tags;

dcpcApi.enhanceEndpoints({ addTagTypes: [DATASOURECES_INVALIDATE_TAG] });
const datasourcesApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({

    getDatasource: builder.query({
      query: (id) => ({
        url: `datasources/${id}`,
        method: 'GET',
      }),
      providesTags: (datasource) => [{ type: DATASOURECES_INVALIDATE_TAG, ...(datasource ? { id: datasource.id } : {}) }],
    }),

    updateDatasource: builder.mutation({
      query: (datasource) => ({
        url: `datasources/${datasource.id}`,
        method: 'PUT',
        body: datasource,
      }),
      invalidatesTags: [DATASOURECES_INVALIDATE_TAG, STATIONS_INVALIDATE_TAG],
    }),

    createDatasource: builder.mutation({
      query: (body) => ({
        url: 'datasources',
        method: 'POST',
        body,
      }),
      invalidatesTags: [STATIONS_INVALIDATE_TAG, DATASOURECES_INVALIDATE_TAG],
    }),

    deleteDatasource: builder.mutation({
      query: (id) => ({
        url: `v2/datasources/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, __, id) => [{ type: DATASOURECES_INVALIDATE_TAG, id }, STATIONS_INVALIDATE_TAG],
    }),

    getDatasourceDeviceByDatasourceId: builder.query({
      query: (id) => `datasources/${id}/devices`,
      providesTags: [STATION_ENTITY_TAG],
    }),

    getDatasourceLogs: builder.query({
      query: ({ params, id }) => ({
        url: `/datasources/${id}/logs`,
        params,
      }),
    }),

    sendHydropadNotification: builder.mutation({
      query: ({ id, body }) => ({
        url: `/datasources/${id}/hydropad-notification`,
        method: 'POST',
        body,
      }),
    }),
    getDatasourceDatasourcePrograms: builder.query({
      query: (id) => `datasources/${id}/datasource-programs`,
      providesTags: [CREATE_DATASOURCE_PROGRAM_TAG, DELETE_DATASOURCE_PROGRAM_TAG],
    }),
  }),
});

export const {
  useGetDatasourceQuery,
  useCreateDatasourceMutation,
  useUpdateDatasourceMutation,
  useDeleteDatasourceMutation,

  useGetDatasourceLogsQuery,
  useGetDatasourceDeviceByDatasourceIdQuery,

  useSendHydropadNotificationMutation,

  useGetDatasourceDatasourceProgramsQuery,
} = adapterForApi(datasourcesApi);

export const datasourcesSelector = createSelector(
  stationsSelector,
  (stations) => stations.reduce((acc, station) => {
    const datasourcesWithStationInfo = station.datasources
      .map((datasource) => ({ ...datasource, station: { idx: station.idx, name: station.name } }));
    return acc.concat(datasourcesWithStationInfo);
  }, []),
);
export const datasourcesByIdsSelector = (ids) => createSelector(
  datasourcesSelector,
  (datasources) => datasources.filter((datasource) => ids.includes(datasource.id)),
);
// export const invalidateDatasource = (id) => invalidateTags([{ type: DATASOURECES_INVALIDATE_TAG, id }]);
